import React, { useEffect } from 'react';

const BadgeEmbed = ({ badgeId, width = 250, height = 250 }) => {
  useEffect(() => {
    // Create a script element to load the Credly embed script
    const script = document.createElement('script');
    script.src = 'https://cdn.credly.com/assets/utilities/embed.js';
    script.async = true;
    script.onload = () => {
      // Initialize the Credly embed script after it loads
      if (window.Credly) {
        window.Credly.render();
      }
    };
    document.body.appendChild(script);

    // Cleanup: remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      data-iframe-width={width}
      data-iframe-height={height}
      data-share-badge-id={badgeId}
      data-share-badge-host="https://www.credly.com"
    ></div>
  );
};

export default BadgeEmbed;